export default __webpack_public_path__ + "static/media/FreeBodyDiagramImg.dc60eaea.jpg";